/**
 * Shared Similar Styles / Similar Products carousel — navigation + Add to Bag.
 * Independent of Delivery / Product Details / Color & Size.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function addToCart(variantId, btn) {
    if (!variantId || !window.routes || !window.routes.cart_add_url) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var originalText = btn.textContent;

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Could not add to cart');
        btn.textContent = 'Added!';
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gf-similar-styles',
            productVariantId: variantId,
            cartData: data,
          });
        }

        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.renderContents(data);
        }

        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.classList.remove('is-loading');
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
  }

  function initCarousel(root) {
    var viewport = root.querySelector('[data-gf-ss-viewport]');
    var track = root.querySelector('[data-gf-ss-track]');
    var nav = root.querySelector('[data-gf-ss-nav]');
    var prev = root.querySelector('[data-gf-ss-prev]');
    var next = root.querySelector('[data-gf-ss-next]');
    if (!viewport || !track || viewport._gfSsCarousel) return;

    viewport._gfSsCarousel = true;

    function cardStep() {
      var card = track.querySelector('.gf-ss-card');
      if (!card) return Math.round(viewport.clientWidth * 0.4);
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }

    function updateNav() {
      if (!nav || !prev || !next) return;
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
      var canScroll = maxScroll > 4;
      nav.hidden = !canScroll;
      if (!canScroll) return;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll;
    }

    function scrollByDir(dir) {
      viewport.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByDir(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByDir(1);
      });
    }

    viewport.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function initRoot(root) {
    if (!root || !root.querySelector('[data-gf-ss-track]')) return;

    initCarousel(root);

    if (root._gfSsAtcBound) return;
    root._gfSsAtcBound = true;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gf-ss-atc]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      if (btn.disabled) return;
      addToCart(btn.getAttribute('data-variant-id'), btn);
    });
  }

  function watchRecommendations(el) {
    if (!el || el._gfSsObserved) return;
    el._gfSsObserved = true;
    var observer = new MutationObserver(function () {
      initRoot(el);
    });
    observer.observe(el, { childList: true, subtree: true });
  }

  ready(function () {
    document.querySelectorAll('[data-gf-ss]').forEach(function (root) {
      initRoot(root);
      if (root.tagName === 'PRODUCT-RECOMMENDATIONS') {
        watchRecommendations(root);
      }
    });
  });
})();
